module.exports = __webpack_public_path__ + "static/media/andy-img.a4458fd5.jpg";